import { toast } from "sonner";
import React from "react";
import i18n from "i18next";
import { Check, X, AlertTriangle, Info, Lock, Hammer } from "lucide-react";
import { getTranslatedError } from "./errorMap";

/**
 * Sistema Globale di Notifiche Toast (Wrapper per Sonner)
 * Tema scuro, icone custom, durate specifiche e stile unificato.
 */

const baseStyle = {
    background: "#1c1c1c",
    color: "#fff",
    border: "1px solid #333",
    borderRadius: "12px",
    padding: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
    fontSize: "14px"
};

export const showSuccess = (message) => {
    toast(message, {
        duration: 3000,
        icon: <Check className="text-green-500" size={18} />,
        style: { ...baseStyle, borderLeft: "4px solid #22c55e" }
    });
};

export const showError = (message) => {
    toast(message, {
        duration: 5000,
        icon: <X className="text-red-500" size={18} />,
        style: { ...baseStyle, borderLeft: "4px solid #ef4444" }
    });
};

/** Show a backend error translated to the user's language */
export const showTranslatedError = (t, error) => {
    const msg = getTranslatedError(t, error);
    showError(msg);
};

export const showWarning = (message) => {
    toast(message, {
        duration: 4000,
        icon: <AlertTriangle className="text-yellow-500" size={18} />,
        style: { ...baseStyle, borderLeft: "4px solid #eab308" }
    });
};

export const showInfo = (message) => {
    toast(message, {
        duration: 3000,
        icon: <Info className="text-blue-500" size={18} />,
        style: { ...baseStyle, borderLeft: "4px solid #3b82f6" }
    });
};

export const showAccessDenied = (message) => {
    const fallback = i18n.t("app.errors.access_denied", "You don't have permission to perform this action.");
    toast(message || fallback, {
        duration: 5000,
        icon: <Lock className="text-rose-900" size={18} />,
        style: { ...baseStyle, borderLeft: "4px solid #881337" }
    });
};

export const showComingSoon = (message) => {
    const fallback = i18n.t("app.errors.coming_soon", "This feature is under development and will be available soon.");
    toast(message || fallback, {
        duration: 4000,
        icon: <Hammer className="text-gray-400" size={18} />,
        style: { ...baseStyle, borderLeft: "4px solid #9ca3af" }
    });
};
